import { get } from 'lodash';

import { Building, Service, StateCities } from '../../services/buildings';
import { Unit } from '../../services/units';
import { ActionInterface } from '../../utils/redux';
import { BuildingActions } from './actions';
import BuildingState, { BuildingStateInterface } from './state';

const INITIAL_STATE = new BuildingState();

export default function BuildingReducer(
  state = INITIAL_STATE,
  action: ActionInterface<BuildingActions>
): BuildingStateInterface {
  switch (action.type) {
    case BuildingActions.getBuildingStart:
      return getBuildingStart(state);
    case BuildingActions.getBuildingSuccess:
      return getBuildingSuccess(state, action);
    case BuildingActions.getBuildingError:
      return getBuildingError(state, action);
    case BuildingActions.getServicesStart:
      return getServicesStart(state);
    case BuildingActions.getServicesSuccess:
      return getServicesSuccess(state, action);
    case BuildingActions.getServicesError:
      return getServicesError(state, action);
    case BuildingActions.getBuildingUnitsStart:
      return getBuildingUnitsStart(state);
    case BuildingActions.getBuildingUnitsSuccess:
      return getBuildingUnitsSuccess(state, action);
    case BuildingActions.getBuildingUnitsError:
      return getBuildingUnitsError(state, action);
    case BuildingActions.getCitiesStart:
      return getCitiesStart(state);
    case BuildingActions.getCitiesSuccess:
      return getCitiesSuccess(state, action);
    case BuildingActions.getCitiesError:
      return getCitiesError(state, action);
    case BuildingActions.getBuildingsStart:
      return getBuildingsStart(state);
    case BuildingActions.getBuildingsSuccess:
      return getBuildingsSuccess(state, action);
    case BuildingActions.getBuildingsError:
      return getBuildingsError(state, action);
    case BuildingActions.setBuildings:
      return setBuildings(state, action);
    default:
      return state;
  }
}

// reducers
function getBuildingStart(state: BuildingStateInterface) {
  return { ...state, error: undefined, loading: true };
}
function getBuildingSuccess(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions, Building>
) {
  return {
    ...state,
    building:
      ({
        ...action.payload,
        services: get(state, 'building.services'),
        units: get(state, 'building.units'),
      } as Building) || null,
    error: null,
  };
}
function getBuildingError(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions>
) {
  return { ...state, building: null, error: action.payload };
}

function getServicesStart(state: BuildingStateInterface) {
  return { ...state, error: undefined, loading: true };
}
function getServicesSuccess(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions, Service[]>
) {
  return {
    ...state,
    building: {
      ...state.building,
      services: action.payload || [],
    } as Building,
    error: null,
  };
}
function getServicesError(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions>
) {
  return { ...state, error: action.payload };
}

function getBuildingUnitsStart(state: BuildingStateInterface) {
  return { ...state, error: undefined, loading: true };
}
function getBuildingUnitsSuccess(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions, Unit[]>
) {
  return {
    ...state,
    building: {
      ...state.building,
      units: action.payload || [],
    } as Building,
    error: null,
  };
}
function getBuildingUnitsError(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions>
) {
  return { ...state, error: action.payload };
}

function getCitiesStart(state: BuildingStateInterface) {
  return { ...state, error: undefined, loading: true };
}
function getCitiesSuccess(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions, StateCities[]>
) {
  return {
    ...state,
    cities: action.payload || [],
    error: null,
  };
}
function getCitiesError(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions>
) {
  return { ...state, cities: null, error: action.payload };
}

function getBuildingsStart(state: BuildingStateInterface) {
  return { ...state, error: undefined, loading: true };
}
function getBuildingsSuccess(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions, Building[]>
) {
  return {
    ...state,
    buildings: action.payload || [],
    error: null,
  };
}
function getBuildingsError(
  state: BuildingStateInterface,
  action: ActionInterface<BuildingActions>
) {
  return { ...state, buildings: null, error: action.payload };
}

function setBuildings(
  state: BuildingStateInterface,
  action: ActionInterface<
    BuildingActions,
    { buildings: Building[]; query: string }
  >
) {
  return {
    ...state,
    buildings: get(action, 'payload.buildings', []),
    query: get(action, 'payload.query', ''),
  };
}
